import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { OpenBillingCheckoutDirective } from '@examdojo/billing';
import { ButtonComponent } from '@examdojo/core/button';
import { TimeAgoModule } from '@examdojo/core/date-time';
import { Entitlement, EntitlementService } from '@examdojo/core/entitlement';
import { ImageComponent } from '@examdojo/core/ui/image';
import { TranslocoPipe } from '@jsverse/transloco';
import { map } from 'rxjs';
import { UserMarksQuery } from './../../../../../user/mark/user-marks-query';

@Component({
  selector: 'dojo-free-grading-menu',
  imports: [TranslocoPipe, ButtonComponent, TimeAgoModule, A11yModule, ImageComponent, OpenBillingCheckoutDirective],
  templateUrl: './free-grading-menu.component.html',
  styleUrl: './free-grading-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreeGradingMenuComponent {
  constructor(
    private readonly userMarksQuery: UserMarksQuery,
    private readonly entitlementService: EntitlementService,
  ) {}

  readonly state = connectState({
    hasUnlimitedCredits: this.entitlementService.selectOne(Entitlement.UnlimitedCredits),
    remainingMarks: this.userMarksQuery.remainingMarks$,
    nextRefresh: this.userMarksQuery.nextRefresh$.pipe(map((date) => (date ? new Date(date) : null))),
    nextRefreshAmount: this.userMarksQuery.nextRefreshAmount$,
  });
}
